import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import onahReducer, { OnahPersistConfig } from "../../persistor";
import { OrderStatusCount } from "interface/store";
import { getOrderCount } from "services/storeFronts";

type TransactionState = {
    orderCount: OrderStatusCount;
}

const initialState: TransactionState = {
    orderCount: {
        cancelled: 0,
        delivered: 0,
        pending: 0,
        refunded: 0
    },
}


export const orderCount = createAsyncThunk('order/orderCount', async (_, thunkApi) => {
    const res = await getOrderCount();
    return res?.data;
});

export const transactionSlice = createSlice({
    name:"trx",
    initialState: initialState,
    reducers:{},
    extraReducers:(builders)=> {
        builders.addCase(orderCount.fulfilled, (state, action) => {
            if(action.payload) {
                state.orderCount = action.payload;
            }
        });
    }
})
// export const {} = userSlice.actions;

const authPersistConfig: OnahPersistConfig = {
    key: transactionSlice.name,
    whitelist: [],
}

export const transactionReducer = onahReducer(authPersistConfig,  transactionSlice.reducer, false);

export const transactionReducerPath = transactionSlice.name;